<h1 mat-dialog-title data-automation-id="adf-confirm-dialog-title">{{ title | translate }}</h1>
<mat-dialog-content>
    <p *ngIf="!htmlContent; else cutomContent" data-automation-id="adf-confirm-dialog-base-message">
        {{ message | translate }}
    </p>
    <form *ngIf="formField" [formGroup]="formGroup" class="pt5">
        <mat-form-field class="w100">
            <mat-label>{{ formFieldLabel | translate
                }}</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="formField"></textarea>
        </mat-form-field>
    </form>
    <ng-template #cutomContent>
        <span [innerHTML]="sanitizedHtmlContent()" data-automation-id="adf-confirm-dialog-custom-content">
        </span>
    </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
    <span class="adf-dialog-spacer" data-automation-id="adf-confirm-dialog-spacer"></span>
    <button id="adf-confirm-cancel" mat-raised-button *ngIf="!hideCancelButton" [mat-dialog-close]="false" color="accent" data-automation-id="adf-confirm-dialog-reject"
        cdkFocusInitial>{{ noLabel | translate }}</button>
    <button id="adf-confirm-all" mat-raised-button *ngIf="thirdOptionLabel" [mat-dialog-close]="thirdOptionLabel"
        data-automation-id="adf-confirm-dialog-confirm-all">{{ thirdOptionLabel | translate }}</button>
    <button id="adf-confirm-accept" mat-raised-button color="primary" data-automation-id="adf-confirm-dialog-confirmation"
        (click)="closeDialog()" [disabled]="formGroup.invalid">{{ yesLabel | translate }}</button>
</mat-dialog-actions>